<template>
  <Container title="枪号管理">
	<!-- 搜索卡片 -->
	<el-card shadow="never" class="search-card">
	  <el-form :model="searchForm" label-position="left" label-width="60px" @submit.prevent @keyup.enter="handleSearch">
		<el-row :gutter="20">
		  <!-- 企业 (仅超管) -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6" v-if="isSuperAdmin">
			<el-form-item label="企业">
			  <el-select v-model="searchForm.enterpriseId" placeholder="请选择企业" clearable style="width: 100%;" @change="handleEnterpriseChange">
				<el-option v-for="item in enterpriseList" :key="item.id" :label="item.name" :value="item.id" />
			  </el-select>
			</el-form-item>
		  </el-col>
		  
		  <!-- 站点 (仅超管) -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6" v-if="isSuperAdmin">
			<el-form-item label="站点">
			  <el-select v-model="searchForm.stationId" placeholder="请选择站点" clearable style="width: 100%;" :disabled="!searchForm.enterpriseId">
				<el-option v-for="item in stationOptions" :key="item.id" :label="item.name" :value="item.id" />
			  </el-select>
			</el-form-item>
		  </el-col>
		  
		  <!-- 枪号 -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6">
			<el-form-item label="枪号">
			  <el-input v-model="searchForm.gunNo" placeholder="请输入枪号" clearable style="width: 100%;" />
			</el-form-item>
		  </el-col>
		  
		  <!-- 时间 -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6">
			<el-form-item label="时间">
			  <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期" value-format="YYYY-MM-DD" :shortcuts="shortcuts" style="width: 100%;" />
			</el-form-item>
		  </el-col>
		  
		  <!-- 按钮区域 -->
		  <el-col :xs="24" :sm="12" :md="6" :lg="6" style="display: flex; justify-content: flex-end;">
			<el-form-item label=" " label-width="0">
			  <div style="display: flex; gap: 8px;">
				<el-button type="primary" @click="handleSearch">查询</el-button>
				<el-button @click="resetSearch">重置</el-button>
			  </div>
			</el-form-item>
		  </el-col>
		</el-row>
	  </el-form>
	</el-card>
	

    <!-- 表格卡片 -->
    <el-card shadow="never" class="table-card">
      <template #header>
        <div class="table-header">
          <div class="table-header-left">
            <el-button v-if="$hasPermission('btn:add_gun')" type="primary" @click="openAddDialog">
              <el-icon><Plus /></el-icon> 添加
            </el-button>
          </div>
          <div class="table-header-right">
            <el-tooltip content="刷新" placement="bottom">
              <el-button circle @click="fetchData"><el-icon><Refresh /></el-icon></el-button>
            </el-tooltip>
            <el-tooltip content="导出" placement="bottom">
              <el-button circle @click="handleExport"><el-icon><Download /></el-icon></el-button>
            </el-tooltip>
            <el-tooltip content="打印" placement="bottom">
              <el-button circle @click="handlePrint"><el-icon><Printer /></el-icon></el-button>
            </el-tooltip>
          </div>
        </div>
      </template>

      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="gun_no" label="枪号" min-width="100" show-overflow-tooltip />
        <el-table-column prop="station_name" label="站点" min-width="140" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" min-width="80" align="center" />
        <el-table-column label="单价(¥)" min-width="100" align="right">
          <template #default="{ row }">{{ (row.price || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="结算单价(¥)" min-width="110" align="right">
          <template #default="{ row }">{{ (row.settlement_price || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="最终单价(¥)" min-width="110" align="right">
          <template #default="{ row }">{{ (row.final_price || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="(站点)让利类型" min-width="120" prop="plan_type" align="center" />
        <el-table-column label="(站点)让利数量" min-width="120" align="right">
          <template #default="{ row }">{{ (row.plan_value || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="(平台)补贴类型" min-width="120" prop="subsidy_type" align="center" />
        <el-table-column label="(平台)补贴比例" min-width="120" align="right">
          <template #default="{ row }">{{ (row.subsidy_value || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
        <el-table-column label="创建时间" min-width="160">
          <template #default="{ row }">{{ formatTime(row.created_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="260" fixed="right" align="center">
          <template #default="{ row }">
            <el-button v-if="$hasPermission('btn:edit_gun')" type="primary" size="small" plain @click="openEditDialog(row)">修改</el-button>
            <el-button v-if="$hasPermission('btn:schedule_gun')" type="warning" size="small" plain @click="handleTiming(row)">定时改价</el-button>
			<el-button type="info" size="small" plain @click="openScheduleList(row)">查看定时任务</el-button>
            <el-button v-if="$hasPermission('btn:delete_gun')" type="danger" size="small" plain @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="page.current"
          v-model:page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="onSizeChange"
          @current-change="fetchData"
        />
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="650px" @close="closeDialog" destroy-on-close>
      <el-card shadow="hover" style="margin-bottom: 10px;">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="140px" label-position="right">
          <el-form-item label="枪号名称：" prop="gun_no">
            <el-input v-model="form.gun_no" placeholder="请输入枪号名称" style="width: 68%;" />
          </el-form-item>

          <el-form-item label="隶属站点：" prop="station_id">
            <el-select
              v-model="form.station_id"
              placeholder="请选择隶属站点"
              style="width: 68%;"
              filterable
            >
              <el-option
                v-for="item in formStationOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="单位：" prop="unit">
            <el-radio-group v-model="form.unit">
              <el-radio :value="'KG'" border>KG</el-radio>
              <el-radio :value="'L'" border>L</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="单价：" prop="price">
            <el-input-number
              v-model="form.price"
              :min="0"
              :precision="2"
              :step="0.1"
              style="width: 68%;"
              @change="calculatePrices"
            />
          </el-form-item>

          <div class="section-divider" style="text-align: center;">站点让利</div>

          <el-form-item label="让利类型：" prop="plan_type">
            <el-radio-group v-model="form.plan_type" @change="calculatePrices">
              <el-radio :value="'百分比'" border>百分比</el-radio>
              <el-radio :value="'金额'" border>金额</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="planLabel + '：'" prop="plan_value">
            <div style="display: flex; align-items: center; gap: 8px; width: 68%;">
              <el-input-number
                v-model="form.plan_value"
                :min="0"
                :precision="2"
                :step="0.1"
                style="flex: 1;"
                @change="calculatePrices"
              />
              <span v-if="form.plan_type === '百分比'" style="color: #909399; white-space: nowrap;">%</span>
            </div>
          </el-form-item>

          <el-form-item label="结算单价：" prop="settlement_price">
            <el-input-number
              v-model="form.settlement_price"
              :min="0"
              :precision="2"
              :step="0.1"
              style="width: 68%;"
              disabled
            />
          </el-form-item>

			<div class="section-divider" style="text-align: center;">平台补贴</div>

			<el-form-item label="补贴类型：" prop="subsidy_type">
			  <el-radio-group
				v-model="form.subsidy_type"
				@change="calculatePrices"
				:disabled="!canEditPlatformSubsidy"
			  >
				<el-radio :value="'百分比'" border>百分比</el-radio>
				<el-radio :value="'金额'" border>金额</el-radio>
			  </el-radio-group>
			</el-form-item>

			<el-form-item :label="subsidyLabel + '：'" prop="subsidy_value">
			  <div style="display: flex; align-items: center; gap: 8px; width: 68%;">
				<el-input-number
				  v-model="form.subsidy_value"
				  :min="0"
				  :precision="2"
				  :step="0.1"
				  style="flex: 1;"
				  @change="calculatePrices"
				  :disabled="!canEditPlatformSubsidy"
				/>
				<span v-if="form.subsidy_type === '百分比'" style="color: #909399; white-space: nowrap;">%</span>
			  </div>
			</el-form-item>

          <el-form-item label="最终单价：" prop="final_price">
            <el-input-number
              v-model="form.final_price"
              :min="0"
              :precision="2"
              :step="0.1"
              style="width: 68%;"
              disabled
            />
          </el-form-item>

          <el-form-item label="备注：" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              style="width: 68%;"
            />
          </el-form-item>
        </el-form>
      </el-card>
      <template #footer>
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">保存</el-button>
      </template>
    </el-dialog>

    <!-- 定时改价弹窗 -->
    <el-dialog
      v-model="timingDialogVisible"
      title="定时改价"
      width="500px"
      @close="resetTimingForm"
      destroy-on-close
    >
      <el-form
        :model="timingForm"
        :rules="timingRules"
        ref="timingFormRef"
        label-width="140px"
        label-position="right"
      >
        <el-form-item label="枪名称：">
          <el-input :value="timingForm.gunName" disabled style="width: 100%;" />
        </el-form-item>
        <el-form-item label="原价格：">
          <el-input :value="timingForm.oldPrice" disabled style="width: 100%;">
            <template #append>元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="任务名称：" prop="taskName">
          <el-input v-model="timingForm.taskName" placeholder="请输入任务名称" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="价格：" prop="newPrice">
          <el-input-number
            v-model="timingForm.newPrice"
            :min="0"
            :precision="2"
            :step="0.1"
            style="width: 100%;"
            placeholder="请输入单价"
          />
        </el-form-item>
        <el-form-item label="执行时间：" prop="executeTime">
          <el-date-picker
            v-model="timingForm.executeTime"
            type="datetime"
            placeholder="请选择单价修改时间"
            value-format="x"
            style="width: 100%;"
            :disabled-date="disabledDate"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="timingDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitTiming" :loading="timingSubmitting">保存</el-button>
      </template>
    </el-dialog>

	<!-- 定时任务列表弹窗 -->
	<el-dialog
	  v-model="scheduleListVisible"
	  :title="`定时任务列表 - ${currentScheduleGunName}`"
	  width="750px"
	  destroy-on-close
	>
	  <el-table :data="currentScheduleList" border style="width: 100%">
		<el-table-column prop="task_name" label="任务名称" min-width="120" />
		<el-table-column prop="target_price" label="目标价格(¥)" min-width="100" align="right">
		  <template #default="{ row }">{{ Number(row.target_price || 0).toFixed(2) }}</template>
		</el-table-column>
		<el-table-column label="执行时间" min-width="160">
		  <template #default="{ row }">{{ formatTime(row.execute_time) }}</template>
		</el-table-column>
		<el-table-column label="状态" min-width="100" align="center">
		  <template #default="{ row }">
			<el-tag v-if="Number(row.status) === 0" type="warning">待执行</el-tag>
			<el-tag v-else-if="Number(row.status) === 1" type="success">已执行</el-tag>
			<el-tag v-else-if="Number(row.status) === 2" type="info">已取消</el-tag>
			<el-tag v-else type="info">未知</el-tag>
		  </template>
		</el-table-column>
		<el-table-column label="操作" width="100" align="center">
		  <template #default="{ row }">
			<el-button
			  v-if="Number(row.status) === 0"
			  type="danger"
			  size="small"
			  plain
			  @click="handleCancelSchedule(row)"
			>取消任务</el-button>
			<span v-else style="color: #999; font-size: 12px;">-</span>
		  </template>
		</el-table-column>
	  </el-table>
	  <template #footer>
		<el-button @click="scheduleListVisible = false">关闭</el-button>
	  </template>
	</el-dialog>

    <!-- 导出弹窗 -->
    <ExportDialog
      v-model:visible="exportDialogVisible"
      :fields="exportFields"
      :export-api="exportApi"
      :get-search-params="getSearchParams"
      :current-page="page"
	  :default-file-name="defaultFileName()"
    />
  </Container>
</template>

<script>
import { pub } from '/common/event';
import moment from 'moment';
import { Plus, Refresh, Download, Printer } from '@element-plus/icons-vue';
import { dateShortcuts } from '../../../utils/shortcuts.js';
import exportMixin from '@/mixins/exportMixin';
import ExportDialog from '@/components/container/ExportDialog.vue';
import enterpriseStationMixin from '@/mixins/enterpriseStationMixin';

export default {
  components: { Plus, Refresh, Download, Printer, ExportDialog },
  mixins: [exportMixin, enterpriseStationMixin],
  data() {
    return {
      shortcuts: dateShortcuts,
      searchForm: { enterpriseId: null, stationId: null, gunNo: '', dateRange: null },

      formStationOptions: [],

      tableData: [],
      total: 0,
      page: { current: 1, pageSize: 15 },
      currentUser: null,

      dialogVisible: false,
      dialogTitle: '新增枪号',
      editId: null,

      form: {
        station_id: null,
        gun_no: '',
        unit: 'KG',
        price: 0,
        settlement_price: 0,
        final_price: 0,
        plan_type: '百分比',
        plan_value: 0,
        subsidy_type: '百分比',
        subsidy_value: 0,
        remark: '',
        status: 1,
      },

      rules: {
        station_id: [{ required: true, message: '请选择站点', trigger: 'change' }],
        gun_no: [{ required: true, message: '请输入枪号名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
      },

      submitting: false,

      timingDialogVisible: false,
      timingSubmitting: false,
      timingCurrentRow: null,
      timingForm: {
        gunName: '',
        oldPrice: 0,
        taskName: '',
        newPrice: 0,
        executeTime: null,
      },
      timingRules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        newPrice: [{ required: true, message: '请输入目标价格', trigger: 'blur' }],
        executeTime: [{ required: true, message: '请选择执行时间', trigger: 'change' }],
      },

	  scheduleListVisible: false,
	  currentScheduleList: [],
	  currentScheduleGunName: '',
	  currentScheduleGunId: null,

      exportFields: [
        { key: 'id', label: '序号列', checked: true },
        { key: 'gun_no', label: '枪号', checked: true },
        { key: 'station_name', label: '站点', checked: true },
        { key: 'unit', label: '单位', checked: true },
        { key: 'price', label: '单价(¥)', checked: true },
        { key: 'settlement_price', label: '结算单价(¥)', checked: true },
        { key: 'final_price', label: '最终单价(¥)', checked: true },
        { key: 'plan_type', label: '让利类型', checked: true },
        { key: 'plan_value', label: '让利数量', checked: true },
        { key: 'subsidy_type', label: '补贴类型', checked: true },
        { key: 'subsidy_value', label: '补贴比例', checked: true },
        { key: 'remark', label: '备注', checked: true },
        { key: 'created_at_label', label: '创建时间', checked: true },
      ],
    };
  },
  computed: {
    isSuperAdmin() {
      return this.currentUser?.role === 'super_admin';
    },
	canEditPlatformSubsidy() {
	  const role = this.currentUser?.role;
	  return ['super_admin', 'station_admin'].includes(role);
	},
    exportApi() {
      return this.$api.gun.export;
    },
    planLabel() {
      return this.form.plan_type === '百分比' ? '让利比例' : '让利金额';
    },
    subsidyLabel() {
      return this.form.subsidy_type === '百分比' ? '补贴比例' : '补贴金额';
    },
  },
  async mounted() {
    this.currentUser = this.$store.state.user.user;
    if (!this.currentUser) {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        try {
          this.currentUser = JSON.parse(userStr);
        } catch (e) {
          this.currentUser = null;
        }
      }
    }

    await this.loadFormStations();
    this.fetchData();
  },
  methods: {
	defaultFileName() {
	  return '枪号数据';
	},
    formatTime(ts) {
      if (!ts) return '';
      return moment(ts).format('YYYY-MM-DD HH:mm:ss');
    },

    async loadFormStations() {
      try {
        const ret = await this.$api.station.page({ status: 1, current: 1, pageSize: 1000 });
        if (ret && ret.success) {
          this.formStationOptions = ret.data?.data || ret.data || [];
        } else {
          console.warn('[loadFormStations] 返回失败:', ret);
        }
      } catch (e) {
        console.error('[loadFormStations] 加载站点列表失败:', e);
      }
    },

    async handleEnterpriseChange(val) {
      this.searchForm.stationId = null;
      this.stationOptions = [];

      if (!val) return;

      try {
        const ret = await this.$api.station.getOptions(val);
        const list = ret?.data?.data || ret?.data || [];
        this.stationOptions = Array.isArray(list) ? list : [];

        if (!this.isSuperAdmin && this.stationOptions.length === 1) {
          this.searchForm.stationId = this.stationOptions[0].id;
        }
      } catch (e) {
        console.error('[handleEnterpriseChange] 加载站点失败:', e);
        pub('error_message', '加载站点失败');
      }
    },

    async fetchData() {
      try {
        const params = {
          page: this.page.current,
          pageSize: this.page.pageSize,
          enterpriseId: this.searchForm.enterpriseId || undefined,
          stationId: this.searchForm.stationId || undefined,
          gunNo: this.searchForm.gunNo || undefined,
        };

        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.startTime = new Date(this.searchForm.dateRange[0]).getTime();
          params.endTime =
            new Date(this.searchForm.dateRange[1]).getTime() + 24 * 60 * 60 * 1000 - 1;
        }

        const ret = await this.$api.gun.page(params);

        if (ret && ret.success) {
          this.tableData = ret.data.data || [];
          this.total = ret.data.total || 0;
          if (ret.data.page) {
            this.page.current = ret.data.page.current;
            this.page.pageSize = ret.data.page.pageSize;
          }
        } else {
          pub('error_message', ret?.message || '加载数据失败');
        }
      } catch (e) {
        console.error('加载枪号列表失败:', e);
        pub('error_message', '请求失败');
      }
    },

    onSizeChange() {
      this.page.current = 1;
      this.fetchData();
    },

    handleSearch() {
      this.page.current = 1;
      this.fetchData();
    },

    resetSearch() {
      this.searchForm = {
        enterpriseId: null,
        stationId: null,
        gunNo: '',
        dateRange: null,
      };
      this.stationOptions = [];
      this.page.current = 1;
      this.fetchData();
    },

    openAddDialog() {
      this.dialogTitle = '新增枪号';
      this.editId = null;
      this.resetForm();

      if (!this.isSuperAdmin && this.formStationOptions.length === 1) {
        this.form.station_id = this.formStationOptions[0].id;
      }

      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef?.clearValidate();
      });
    },

    openEditDialog(row) {
      this.dialogTitle = '编辑枪号';
      this.editId = row.id;
      this.form = {
        ...row,
        station_id: row.station_id,
        gun_no: row.gun_no,
        unit: row.unit,
        price: parseFloat(row.price) || 0,
        settlement_price: parseFloat(row.settlement_price) || 0,
        final_price: parseFloat(row.final_price) || 0,
        plan_type: row.plan_type || '百分比',
        plan_value: parseFloat(row.plan_value) || 0,
        subsidy_type: row.subsidy_type || '百分比',
        subsidy_value: parseFloat(row.subsidy_value) || 0,
        remark: row.remark || '',
        status: row.status,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef?.clearValidate();
        this.calculatePrices();
      });
    },

    closeDialog() {
      this.dialogVisible = false;
      this.editId = null;
      this.resetForm();
    },

    resetForm() {
      this.form = {
        station_id: null,
        gun_no: '',
        unit: 'KG',
        price: 0,
        settlement_price: 0,
        final_price: 0,
        plan_type: '百分比',
        plan_value: 0,
        subsidy_type: '百分比',
        subsidy_value: 0,
        remark: '',
        status: 1,
      };
      if (!this.isSuperAdmin && this.formStationOptions.length === 1) {
        this.form.station_id = this.formStationOptions[0].id;
      }
    },

    calculatePrices() {
      const price = parseFloat(this.form.price) || 0;
      const planType = this.form.plan_type;
      const planValue = parseFloat(this.form.plan_value) || 0;
      const subsidyType = this.form.subsidy_type;
      const subsidyValue = parseFloat(this.form.subsidy_value) || 0;

      const discount = planType === '百分比' ? price * (planValue / 100) : planValue;
      const settlementPrice = price - discount;

      const subsidy =
        subsidyType === '百分比' ? settlementPrice * (subsidyValue / 100) : subsidyValue;
      const finalPrice = settlementPrice - subsidy;

      this.form.settlement_price = Math.max(0, settlementPrice);
      this.form.final_price = Math.max(0, finalPrice);
    },

    async submitForm() {
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.calculatePrices();
      this.submitting = true;
      try {
        const data = { ...this.form };
        delete data.station_name;

        let ret;
        if (this.editId) {
          data.id = this.editId;
          ret = await this.$api.gun.update(data);
        } else {
          ret = await this.$api.gun.create(data);
        }

        if (ret && ret.success) {
          pub('success_message', this.editId ? '编辑成功' : '添加成功');
          this.closeDialog();
          this.fetchData();
        } else {
          pub('error_message', ret?.message || '操作失败');
        }
      } catch (e) {
        console.error('提交失败:', e);
        pub('error_message', '请求失败');
      } finally {
        this.submitting = false;
      }
    },

    handleDelete(row) {
      this.$confirm('确定要删除该枪号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const ret = await this.$api.gun.delete(row.id);
            if (ret && ret.success) {
              pub('success_message', '删除成功');
              this.fetchData();
            } else {
              pub('error_message', ret?.message || '删除失败');
            }
          } catch (e) {
            pub('error_message', '请求失败');
          }
        })
        .catch(() => {});
    },

    handleTiming(row) {
      this.timingCurrentRow = row;
      this.timingForm = {
        gunName: row.gun_no || '',
        oldPrice: parseFloat(row.price) || 0,
        taskName: '',
        newPrice: parseFloat(row.price) || 0,
        executeTime: null,
      };
      this.timingDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.timingFormRef?.clearValidate();
      });
    },

    resetTimingForm() {
      this.timingForm = {
        gunName: '',
        oldPrice: 0,
        taskName: '',
        newPrice: 0,
        executeTime: null,
      };
      this.timingCurrentRow = null;
    },

	async openScheduleList(row) {
	  this.currentScheduleGunId = row.id;
	  this.currentScheduleGunName = row.gun_no;
	  this.currentScheduleList = [];
	  this.scheduleListVisible = true;

	  try {
		const ret = await this.$api.gun.getScheduleList({ gunId: row.id });
		if (ret && ret.success) {
		  this.currentScheduleList = ret.data || [];
		} else {
		  pub('error_message', ret?.message || '获取定时任务失败');
		}
	  } catch (e) {
		console.error('获取定时任务失败', e);
		pub('error_message', '请求失败');
	  }
	},

	handleCancelSchedule(task) {
	  this.$confirm('确定要取消该定时改价任务吗？', '提示', {
		confirmButtonText: '确定取消',
		cancelButtonText: '再想想',
		type: 'warning',
	  }).then(async () => {
		try {
		  const ret = await this.$api.gun.cancelSchedule({ id: task.id });
		  if (ret && ret.success) {
			pub('success_message', '任务已取消');
			this.openScheduleList({ id: this.currentScheduleGunId, gun_no: this.currentScheduleGunName });
		  } else {
			pub('error_message', ret?.message || '取消失败');
		  }
		} catch (e) {
		  pub('error_message', '请求失败');
		}
	  }).catch(() => {});
	},

    disabledDate(time) {
      return time.getTime() <= Date.now();
    },

    async submitTiming() {
      try {
        await this.$refs.timingFormRef.validate();
      } catch (e) {
        return;
      }
      if (!this.timingCurrentRow) {
        pub('error_message', '未选择枪号');
        return;
      }

      const execTime = parseInt(this.timingForm.executeTime);
      const now = Date.now();
      if (execTime <= now) {
        pub('error_message', '执行时间必须为未来的时间');
        return;
      }

      this.timingSubmitting = true;
      try {
        const ret = await this.$api.gun.schedulePrice({
          gunId: this.timingCurrentRow.id,
          taskName: this.timingForm.taskName,
          targetPrice: this.timingForm.newPrice,
          executeTime: this.timingForm.executeTime,
        });

        if (ret && ret.success) {
          pub(
            'success_message',
            `定时任务 "${this.timingForm.taskName}" 创建成功，将于 ${moment(execTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )} 执行`
          );
          this.timingDialogVisible = false;
          this.fetchData();
        } else {
          pub('error_message', ret?.message || '创建定时任务失败');
        }
      } catch (e) {
        console.error('创建定时任务失败:', e);
        pub('error_message', '请求失败，请重试');
      } finally {
        this.timingSubmitting = false;
      }
    },

    handleExport() {
      this.openExportDialog();
    },

    handlePrint() {
      window.print();
    },
  },
};
</script>

<style scoped>
.search-card { margin-bottom: 16px; }
.search-card .el-form-item { margin-bottom: 0; }
.table-card :deep(.el-card__header) { padding: 10px 16px; border-bottom: 1px solid #e4e7ed; }
.table-header { display: flex; justify-content: space-between; align-items: center; width: 100%; }
.table-header-left { display: flex; align-items: center; gap: 8px; }
.table-header-right { display: flex; align-items: center; gap: 4px; }
.pagination-wrapper { display: flex; justify-content: center; margin-top: 16px; }
.section-divider {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  padding: 12px 0 6px 0;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 12px;
}
:deep(.el-radio.is-bordered) {
  padding: 8px 18px;
  margin-right: 12px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: border-color 0.2s;
}
:deep(.el-radio.is-bordered.is-checked) {
  border-color: #409EFF;
  box-shadow: 0 0 0 1px #409EFF;
}
:deep(.el-radio.is-bordered .el-radio__label) {
  font-size: 14px;
  color: #606266;
}
:deep(.el-radio.is-bordered.is-checked .el-radio__label) {
  color: #409EFF;
}
</style>